import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class ModuleList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: [],
      // user: {},
      // updated: false,
      // searched: false,
      loading: true
    };

    this.error = this.error.bind(this);
    this.insertAbilities = this.insertAbilities.bind(this);
    this.deleteAbilities = this.deleteAbilities.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  insertAbilities() {
    this.props.history.push("/ability/module/form");
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.handleAbilities();
  }

  handleAbilities() {
    axios
      .get(`${URL.api}classification/ability/list`, {
        params: { type: "educandus" },
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState(
            () => ({
              list: null
            }),
            () => {
              if (resp.data.data.length === 0) {
                this.setState(() => ({
                  list: [],
                  loading: false
                }));
              } else {
                this.setState(
                  () => ({
                    list: resp.data.data,
                    loading: false
                  }),
                  () => {
                    this.forceUpdate();
                  }
                );
              }
            }
          );
        },
        error => {
          this.error("Não foi possível listar os módulos");
        }
      );
  }

  deleteAbilities(rows) {
    const obj = {
      abilities: rows
    };

    axios
      .post(`${URL.api}classification/ability/deleteMany`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.handleAbilities();
        },
        () => {
          this.error("Não foi possível apagar os módulos");
        }
      );
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Breadcrumb current={this.props.currentRoute} />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            {this.state.list ? (
              <div id="list">
                <DataTable
                  list={this.state.list}
                  path="/ability/module/edit/"
                  title="Módulos"
                  header={[
                    { name: "id", denomination: "ID" },
                    { name: "code", denomination: "Código" },
                    { name: "description", denomination: "Descricao" },
                    { name: "objective_id", denomination: "Objetivo" }
                  ]}
                  insert
                  delete
                  insertAction={this.insertAbilities}
                  deleteAction={this.deleteAbilities}
                />
              </div>
            ) : (
              <Loading />
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ModuleList);
